
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-study/sedar-global",
      function () {
        return require("private-next-pages/case-study/sedar-global.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-study/sedar-global"])
      });
    }
  